import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBuilding = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M12.25 18.25V3.35C12.25 2.78995 12.25 2.50992 12.141 2.29601C12.0451 2.10785 11.8922 1.95487 11.704 1.85899C11.4901 1.75 11.2101 1.75 10.65 1.75H5.35C4.78995 1.75 4.50992 1.75 4.29601 1.85899C4.10785 1.95487 3.95487 2.10785 3.85899 2.29601C3.75 2.50992 3.75 2.78995 3.75 3.35V18.25H12.25ZM12.25 18.25H16.25V9.35C16.25 8.78995 16.25 8.50992 16.141 8.29601C16.0451 8.10785 15.8922 7.95487 15.704 7.85899C15.4901 7.75 15.2101 7.75 14.65 7.75H12.25M18.25 18.25H1.75M6.75 5.75H9.25M6.75 10H9.25M6.75 14.25H9.25",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
const ForwardRef = forwardRef(SvgBuilding);
export { ForwardRef as ReactComponent };
